(function(){
  if(window.__kaionSavingsInit) return;
  window.__kaionSavingsInit = true;

  var productCache = {};

  function formatMoney(cents){
    return (cents/100).toLocaleString('pt-BR', {style:'currency', currency:'BRL'});
  }
/*
  function renderSavings(cents){
    var holder = document.querySelector('[data-cart-price-holder]');
    if(!holder) return;
    var existing = holder.querySelector('.cart__savings');
    if(cents <= 0){
      if(existing) existing.remove();
      return;
    }
    var html = '<div class="cart__total cart__savings"><span>Você economizou</span><span class="cart__savings__amount">-' + formatMoney(cents) + '</span></div>';
    if(existing){
      existing.outerHTML = html;
    } else {
      holder.insertAdjacentHTML('afterbegin', html);
    }
  }*/

  function getProductData(handle){
    if(productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js').then(function(r){ return r.json(); });
    return productCache[handle];
  }

  function recalcSavings(){
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var handles = [];
        cart.items.forEach(function(item){
          if(handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });

        Promise.all(handles.map(getProductData)).then(function(products){
          var compareMap = {};
          products.forEach(function(p){
            p.variants.forEach(function(v){
              compareMap[v.id] = v.compare_at_price || 0;
            });
          });

          var total = 0;
          cart.items.forEach(function(item){
            var compareAt = compareMap[item.variant_id] || 0;
            if(compareAt > item.price){
              total += (compareAt - item.price) * item.quantity;
            }
          });

          renderSavings(total);
        });
      })
      .catch(function(){});
  }

  var debounceTimer = null;
  function scheduleRecalc(){
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(recalcSavings, 200);
  }

  var observer = new MutationObserver(scheduleRecalc);
  observer.observe(document.body, {childList:true, subtree:true});

  recalcSavings();
})();